import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

import { rockGemsApi } from "../services/rockGemsApi";
import ErrorAlert from "../components/common/ErrorAlert";
import LoadingBlock from "../components/common/LoadingBlock";

export default function DashboardPage() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      setLoading(true);
      setError(null);
      try {
        const data = await rockGemsApi.getStatistics();
        if (!cancelled) setStats(data);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="page-pretitle">Dashboard</div>
              <h2 className="page-title">Gems statistics</h2>
            </div>
          </div>
        </div>
      </div>

      <ErrorAlert error={error} title="Failed to load statistics" />
      {loading ? <LoadingBlock label="Loading statistics..." /> : null}

      {!loading && stats ? (
        <Row className="row-deck row-cards">
          <Col xs={12} md={6}>
            <Card>
              <Card.Body>
                <div className="text-muted">Categories</div>
                <div className="h1 mb-0">{stats.categories_total ?? "—"}</div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6}>
            <Card>
              <Card.Body>
                <div className="text-muted">Gems</div>
                <div className="h1 mb-0">{stats.gems_total ?? "—"}</div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : null}
    </div>
  );
}

